import TypeformQuestionWithAnswerList from '@cohort/merchants/apps/typeform/triggerIntegrations/TypeformQuestionWithAnswerList';
import type {TypeformFillFormVerificationAttemptData} from '@cohort/shared/schema/apps/typeform/triggers/fillForm';
import {Trans} from 'react-i18next';

const TypeformFillFormTriggerIntegrationStepCompletionComponent: React.FC<{
  data: TypeformFillFormVerificationAttemptData;
}> = ({data}) => {
  const {questionsWithAnswers, formTitle} = data;

  return (
    <div className="space-y-4 text-slate-700">
      <Trans
        i18nKey="triggerIntegrations.fill-form.stepCompletionComponent.completedFormTitle"
        ns="app-typeform"
        values={{
          title: formTitle,
        }}
        components={{
          span: <span className="font-medium text-slate-900" />,
        }}
      />

      <TypeformQuestionWithAnswerList questionsWithAnswers={questionsWithAnswers} />
    </div>
  );
};

export default TypeformFillFormTriggerIntegrationStepCompletionComponent;
